module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Special thanks to theater director and playwright Jeremy Cole for his intrepid dedication and guidance on ongoing drafts of this novel; to novelist Chris Kenry for his encouragement and suggestions; to George Ware, Kristen Hannum, John Serini, and the late, great Jack Long for invaluable feedback; to Peter Knapp and Bruce Morgan for specific revision advice.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c385e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/005.vue
// module id = 66
// module chunks = 0